import { fg } from '@atlaskit/platform-feature-flags';
import { getStudioSessionSyncUrl } from '@atlassian/studio-entry-link';

const STUDIO_URL = 'https://studio.atlassian.com';
const STUDIO_URL_STAGING = 'https://atlassian-studio.stg-east.frontend.public.atl-paas.net';

const isStaging = (): boolean => {
	const host = window.location.host;
	return (
		host.includes('localhost') ||
		host.includes('.stg.atlassian') ||
		host.includes('.stg-east.frontend.public.atl-paas.net') ||
		host.includes('jira-dev.com')
	);
};

const getStudioEnv = (): 'production' | 'staging' => (isStaging() ? 'staging' : 'production');

export const getStudioEditorUrl = (
	helpCenterId: string,
	cloudId: string,
	pageId?: string | null,
	email?: string,
): string => {
	const studioUrl = isStaging() ? STUDIO_URL_STAGING : STUDIO_URL;

	if (fg('asf-944-account-sync')) {
		const path = !pageId
			? `/s/${cloudId}/hubs/${helpCenterId}`
			: `/s/${cloudId}/hubs/${helpCenterId}/pages/${pageId}`;
		return getStudioSessionSyncUrl(getStudioEnv(), path, email);
	}

	if (!pageId) {
		return `${studioUrl}/s/${cloudId}/hubs/${helpCenterId}`;
	}
	return `${studioUrl}/s/${cloudId}/hubs/${helpCenterId}/pages/${pageId}`;
};
